'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toggleEmailSubscription = exports.fetchEmailListsIfNeeded = exports.getEmailList = exports.getEmailLists = exports.UNSUBSCRIBE_SUCCESS = exports.UNSUBSCRIBE_REQUEST = exports.UNSUBSCRIBE_FAIL = exports.SUBSCRIBE_SUCCESS = exports.SUBSCRIBE_REQUEST = exports.SUBSCRIBE_FAIL = exports.LOAD_EMAIL_LIST_SUCCESS = exports.LOAD_EMAIL_LIST_REQUEST = exports.LOAD_EMAIL_LIST_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _reselect = require('reselect');

var _user = require('../modules/user');

var _config = require('../modules/config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_EMAIL_LIST_FAIL = exports.LOAD_EMAIL_LIST_FAIL = 'la/user/emailList/LOAD_FAIL';
var LOAD_EMAIL_LIST_REQUEST = exports.LOAD_EMAIL_LIST_REQUEST = 'la/user/emailList/LOAD_REQUEST';
var LOAD_EMAIL_LIST_SUCCESS = exports.LOAD_EMAIL_LIST_SUCCESS = 'la/user/emailList/LOAD_SUCCESS';

var SUBSCRIBE_FAIL = exports.SUBSCRIBE_FAIL = 'la/user/emailList/SUBSCRIBE_FAIL';
var SUBSCRIBE_REQUEST = exports.SUBSCRIBE_REQUEST = 'la/user/emailList/SUBSCRIBE_REQUEST';
var SUBSCRIBE_SUCCESS = exports.SUBSCRIBE_SUCCESS = 'la/user/emailList/SUBSCRIBE_SUCCESS';

var UNSUBSCRIBE_FAIL = exports.UNSUBSCRIBE_FAIL = 'la/user/emailList/UNSUBSCRIBE_FAIL';
var UNSUBSCRIBE_REQUEST = exports.UNSUBSCRIBE_REQUEST = 'la/user/emailList/UNSUBSCRIBE_REQUEST';
var UNSUBSCRIBE_SUCCESS = exports.UNSUBSCRIBE_SUCCESS = 'la/user/emailList/UNSUBSCRIBE_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('5m');

// reducer
var DEFAULT_STATE = {
    lists: [],
    loaded: 0,
    loading: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var lists = void 0;

    switch (action.type) {
        case LOAD_EMAIL_LIST_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_EMAIL_LIST_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_EMAIL_LIST_SUCCESS:
            return (0, _extends3.default)({}, state, {
                lists: action.payload,
                loaded: action.meta.actionTime,
                loading: false
            });
        case SUBSCRIBE_REQUEST:
            lists = [].concat((0, _toConsumableArray3.default)(state.lists));
            if (action.payload === 'Unsubscribed All') {
                lists.forEach(function (x) {
                    if (x.type === 'newsletter') {
                        x.subscribed = true;
                    }
                });
            } else {
                lists.forEach(function (x) {
                    if (x.code === action.payload) {
                        x.subscribed = true;
                    }
                });
            }
            return (0, _extends3.default)({}, state, {
                lists: lists
            });
        case UNSUBSCRIBE_REQUEST:
            lists = [].concat((0, _toConsumableArray3.default)(state.lists));
            if (action.payload === 'Unsubscribed All') {
                lists.forEach(function (x) {
                    if (x.type === 'newsletter') {
                        x.subscribed = false;
                    }
                });
            } else {
                lists.forEach(function (x) {
                    if (x.code === action.payload) {
                        x.subscribed = false;
                    }
                });
            }
            return (0, _extends3.default)({}, state, {
                lists: lists
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.user.emailList;
};
var codeSelector = function codeSelector(state, code) {
    return code;
};

var getEmailLists = exports.getEmailLists = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.lists && state.lists.sort(function (a, b) {
        return a.type - b.type;
    }).sort(function (a, b) {
        return a.sequence - b.sequence;
    }) || [];
});

var getEmailList = exports.getEmailList = (0, _reselect.createSelector)([stateSelector, codeSelector], function (state, code) {
    return state.lists.find(function (x) {
        return x.code === code;
    }) || {};
});

var getLoadTime = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded || 0;
});

var isLoading = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading || false;
});

var shouldFetchEmailLists = function shouldFetchEmailLists(state) {
    var loaded = getLoadTime(state);
    var time = Date.now();
    var diff = time - loaded;
    if (diff < REDUX_STORE_TIME) return false;
    return !isLoading(state);
};

/* ACTION CREATORS */
var fetchEmailListsIfNeeded = exports.fetchEmailListsIfNeeded = function fetchEmailListsIfNeeded() {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, authToken, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();

                            if (!shouldFetchEmailLists(state)) {
                                _context.next = 17;
                                break;
                            }

                            deployment = (0, _config.getDeployment)(state);
                            _context.prev = 3;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                type: LOAD_EMAIL_LIST_REQUEST
                            });
                            authToken = (0, _user.getAuthToken)(state);
                            _context.next = 8;
                            return _api.EmailList.fetchEmailLists({ authToken: authToken, deployment: deployment });

                        case 8:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_EMAIL_LIST_SUCCESS
                            });
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](3);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: LOAD_EMAIL_LIST_FAIL
                            });

                        case 15:
                            _context.next = 18;
                            break;

                        case 17:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 18:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[3, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var toggleEmailSubscription = exports.toggleEmailSubscription = function toggleEmailSubscription(code) {
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, authToken, deployment, list, response, _response;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            list = getEmailList(state, code);

                            if (!(list.subscribed || code === 'Unsubscribed All')) {
                                _context2.next = 18;
                                break;
                            }

                            dispatch({
                                payload: code,
                                type: UNSUBSCRIBE_REQUEST
                            });
                            _context2.prev = 6;
                            _context2.next = 9;
                            return _api.EmailList.postUnsubscribeFromEmailList({
                                authToken: authToken,
                                code: code,
                                deployment: deployment
                            });

                        case 9:
                            response = _context2.sent;

                            dispatch({
                                meta: { code: code },
                                payload: response.data,
                                type: UNSUBSCRIBE_SUCCESS
                            });
                            _context2.next = 16;
                            break;

                        case 13:
                            _context2.prev = 13;
                            _context2.t0 = _context2['catch'](6);

                            dispatch({
                                error: true,
                                meta: { code: code },
                                payload: _context2.t0,
                                type: UNSUBSCRIBE_FAIL
                            });

                        case 16:
                            _context2.next = 29;
                            break;

                        case 18:
                            dispatch({
                                payload: code,
                                type: SUBSCRIBE_REQUEST
                            });
                            _context2.prev = 19;
                            _context2.next = 22;
                            return _api.EmailList.postSubscribeToEmailList({ authToken: authToken, code: code, deployment: deployment });

                        case 22:
                            _response = _context2.sent;

                            dispatch({
                                meta: { code: code },
                                payload: _response.data,
                                type: SUBSCRIBE_SUCCESS
                            });
                            _context2.next = 29;
                            break;

                        case 26:
                            _context2.prev = 26;
                            _context2.t1 = _context2['catch'](19);

                            dispatch({
                                error: true,
                                meta: { code: code },
                                payload: _context2.t1,
                                type: SUBSCRIBE_FAIL
                            });

                        case 29:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[6, 13], [19, 26]]);
        }));

        return function (_x5, _x6) {
            return _ref2.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/emailList.js
// module id = CCNV
// module chunks = 57